export interface Testimonial {
  quote: string;
  author: string;
  role: string;
  location: string;
}

// Single, high-impact testimonial shown right after the problem section.
export const heroTestimonial: Testimonial = {
  quote:
    'Compré el manual un domingo por la noche desesperado por la clase del lunes. Es increíble: abres el PDF, eliges la ficha y tienes la sesión montada en 2 minutos. Mis alumnos notaron la diferencia al instante y yo recuperé mi tiempo libre. El mejor dinero invertido este año.',
  author: 'Carlos M.',
  role: 'Monitor argentino en club',
  location: 'Madrid'
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Llevaba dos temporadas dando clases sin saber si lo estaba haciendo bien. Con este manual por primera vez siento que hay un hilo conductor real en mis sesiones.',
    author: 'Sergio B.',
    role: 'Monitor',
    location: 'Valencia'
  },
  {
    quote:
      'Lo que más me ha flipado es el Semáforo de Errores. Antes me costaba explicar por qué fallaban la bandeja sin soltar un discurso pesado. Ahora uso las consignas del manual y los alumnos lo pillan a la primera. Me ven mucho más profesional y yo me siento más seguro en pista.',
    author: 'Raquel F.',
    role: 'Entrenadora Nivel 1',
    location: 'Barcelona'
  },
  {
    quote:
      'El Programador 12 Meses es lo que hace que todo encaje. Ahora sigo el calendario y los alumnos progresan de forma visible cada semana.',
    author: 'Tomás V.',
    role: 'Monitor',
    location: 'Alicante'
  }
];
